module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ3_1.47d4e3ef.svg";